import React from "react";
import { array, string } from "prop-types";

import "./TableWidget.m.css";

const TableWidget = ({ customStyleName, tBodyData, tHeadData }) => {
  return (
    <div styleName={`table-widget ${customStyleName}`}>
      <table styleName="table">
        <thead styleName="table-header">
          <tr>
            {tHeadData.map((headline, index) => {
              return <th key={`headline-${index}`}>{headline}</th>;
            })}
          </tr>
        </thead>
        <tbody styleName="table-body">
          {tBodyData.map((item, index) => {
            return (
              <tr key={`data-${index}`}>
                <td>{item["current-rank"] || item?.rank}</td>
                <td>{item.name}</td>
                {<td>{item.revenue}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

TableWidget.defaultProps = {
  customStyleName: "",
  tBodyData: [],
  tHeadData: [],
};

TableWidget.propTypes = {
  customStyleName: string,
  tBodyData: array,
  tHeadData: array,
};

export default TableWidget;
